export default (that, disabled) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    visible: !disabled,
    slots: {
      default: 'opt'
    }
  },
  {
    field: 'col-opt-detail',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    visible: !!disabled,
    slots: {
      default: 'detailOpt'
    }
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'defaultImageUrl' }
  },
  {
    title: that.$l('from_label_sample_name') || '样品名称',
    field: 'sampleName',
    minWidth: 300,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayName' }
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_Level_2_sample_classification') || '样品分类',
    field: 'v_categoryCode',
    minWidth: 120,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true
  },

  {
    title: that.$l('table_label_sampleSpec') || '产品规格',
    field: 'specInfo',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'specInfo' }
  },

  {
    title: that.$l('table_label_in_set_name') || '套内名称',
    field: 'inSetNameEn',
    minWidth: 120,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_in_set_qty') || '套内数量',
    field: 'inSetQty',
    minWidth: 120,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_sample_com') || '产品成分',
    field: 'sampleComposition',
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_costMainType') || '成本类型',
    field: 'v_costMainType',
    minWidth: 160,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_costPrice') || '成本价格',
    field: 'costPrice',
    minWidth: 200,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'costPrice' }
  },
  {
    title: that.$l('table_label_quotation_method') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 150,
    align: 'left',
    headerAlign: 'left',
    showHeaderOverflow: true,
    slots: { default: 'quotedMethod' }
  },
    {
    title: that.$l('table_label_packageSize') || '包装尺寸',
    field: 'packageSize',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_packageMethod') || '包装方式',
    field: 'packageMethodName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    slots: { default: 'createInfo' }
  },
  {
    field: 'modifyByName',
    align: 'left',
    width: 170,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' }
  }
]
